module.exports = __webpack_public_path__ + "static/media/banner4.d1351a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/banner4.png
// module id = 45
// module chunks = 0